"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getStationId = (dat, reading) => {
  const {
    StationId
  } = reading;
  const {
    reverse,
    endStn,
    calcEnd,
    startStn,
    calcStart
  } = dat;
  if (reverse) {
    if (endStn !== undefined) {
      return endStn - StationId;
    }
    return calcEnd - StationId;
  }
  if (startStn !== undefined) {
    return startStn + StationId;
  }
  return calcStart + StationId;
};
var _default = getStationId;
exports.default = _default;